"use strict";import{IconAlert as e}from"../src/elements/IconAlert.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-icon-alert",e);
//# sourceMappingURL=sp-icon-alert.js.map
